export const FEATURES = [
  {
    tag: "01 // UPLOAD",
    title: "Drop. Upload. Done.",
    desc: "Drag in a document and SmartDocQ prepares it for search, questions, summaries, and retrieval.",
    metaText: "PDF · DOCX · XLSX · CSV · TXT"
  },
  {
    tag: "02 // ASK",
    title: "Ask. Understand.",
    desc: "Ask questions in plain English and get answers grounded in your documents.",
    metaText: "GROUNDED IN · PAGE 12 · §4.2"
  },
  {
    tag: "03 // SUMMARIZE",
    title: "Instant Summaries",
    desc: "Turn long documents into concise summaries while keeping the important information intact.",
    metaText: "EXECUTIVE SUMMARY · BULLET DIGEST"
  },
  {
    tag: "04 // STUDY",
    title: "Quizzes & Flashcards",
    desc: "Turn any document into interactive quizzes, flashcards, and practice questions with explanations and instant feedback.",
    metaText: "FLASHCARDS · PRACTICE QUIZZES"
  },
  {
    tag: "05 // REMEMBER",
    title: "Document Chat Memory",
    desc: "Pick up where you left off. Every document retains its own chat history, context, and answers for seamless ongoing conversations.",
    metaText: "PERSISTENT CHAT MEMORY"
  },
  {
    tag: "06 // IMPROVE",
    title: "Your Feedback Matters",
    desc: "Rate responses and help improve answer quality, relevance, and overall document understanding over time.",
    metaText: "ACTIVE RETRIEVAL TUNING"
  },
  {
    tag: "07 // ORGANIZE",
    title: "Your Digital Workspace",
    desc: "Keep documents, chats, summaries, quizzes, and exports organized in one place with quick access to everything you've created.",
    metaText: "DOCUMENTS · CHATS · SUMMARIES · EXPORTS"
  },
  {
    tag: "08 // PROTECT",
    title: "Built-In Safety",
    desc: "From secure access controls to sensitive data detection and intelligent content safeguards, SmartDocQ is designed with safety at every step.",
    metaText: "ACCESS CONTROL · DATA SAFETY · SAFEGUARDS"
  }
];